import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/deleteIcon.svg'


const _withScopeId = n => (_pushScopeId("data-v-6b15dc2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "upload-content"
}
const _hoisted_9 = { class: "upload-progress" }

import request from '@/utils/request'
import { computed, ref, watch } from 'vue'
import { Form } from 'ant-design-vue'
import { DcMessage } from '@dc-platform/dc-components'
import excel from '@/assets/uploadFile/excel.svg'
import pdf from '@/assets/uploadFile/pdf.svg'
import ppt from '@/assets/uploadFile/ppt.svg'
import txt from '@/assets/uploadFile/txt.svg'
import word from '@/assets/uploadFile/word.svg'
import { useI18n } from 'vue-i18n'
type FileListTypes = {
  name: string
  uid: string
  status: string
  url: string
  response?: string
}
type UploadFileTypes = {
  name: string
  uid: string
  status: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'uploadFile',
  props: {
  value: {
    type: [String, Array]
  },
  maxCount: {
    type: Number,
    default: 10
  },
  action: {
    type: String,
    default: '/base/resource/file/upload'
  },
  uploadText: {
    type: String
  },
  disabled: {
    type: Boolean,
    default: false
  },
  tips: {
    type: String,
    default: ''
  },
  view: {
    type: Boolean
  },
  type: {
    type: String,
    default: 'edit' // 定义样式 detail 详情样式
  },
  valueType: {
    type: String,
    default: 'string' // 定义值格式 array 数组
  },
  accept: {
    type: String,
    default: '.xlsx,.xls,.doc,.docx,.pdf,.png,.jpg' // 定义样式 detail 详情样式
  },
  fileSize: {
    type: Number,
    default: 20 // 20M
  }
},
  emits: ['update:value'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const iconList = ref<object>({
  excel: excel,
  pdf: pdf,
  ppt: ppt,
  txt: txt,
  word: word
})
const props = __props
const tipsComputed = computed(() => {
  if (props.tips) {
    return props.tips
  }
  const { accept, maxCount, fileSize } = props
  return t('tips.importSizeFileType', { fileType: accept, fileNum: maxCount, fileSize })
})
const uploadFile = ref<UploadFileTypes>()
const formItemContext = Form.useInjectFormItemContext()
const progress = ref<number>(10)
const fileList = ref<FileListTypes[]>([])
const resultFileList = ref<string>('')
const emit = __emit
const fileFormatter = (data: any) => {
  const name = data.split('/')
  let suffix = ''
  let contentType = ''
  try {
    const flieArr = name.split('.')
    suffix = flieArr[flieArr.length - 1]
  } catch (err) {
    suffix = ''
  }
  suffix = suffix.toLocaleLowerCase() // 将后缀所有字母改为小写
  if (['jpg', 'jpeg'].find((item) => item === suffix)) {
    contentType = 'IMAGE/JPEG'
  } else if (['png'].find((item) => item === suffix)) {
    contentType = 'IMAGE/PNG'
  }

  const file: {
    name: string
    uid: string
    status: string
    url: string
    response: string
  } = {
    name: name[name.length - 1],
    uid: data,
    status: 'done',
    url: contentType.length === 0 ? data : data + '?response-content-type=' + contentType,
    response: '{"status": "success"}' // 服务端响应内容
  }
  return file
}
watch(
  () => props.value,
  (v) => {
    if (v) {
      let arr = []
      if (typeof v === 'string') {
        if (v !== resultFileList.value) {
          arr = v.split(',')
        }
      } else if (Array.isArray(v)) {
        if (v.join(',') !== resultFileList.value) {
          arr = v
        }
      }
      if (arr.length) {
        fileList.value = []
        arr.forEach((item) => {
          fileList.value?.push(fileFormatter(item))
        })
      }
    } else {
      resultFileList.value = ''
      fileList.value = []
    }
  },
  { immediate: true }
)

const change = () => {
  const url = fileList.value.map((item) => item.url)
  resultFileList.value = url.join(',')
  if (props.valueType === 'string') {
    emit('update:value', url.join(','))
  } else if (props.valueType === 'array') {
    emit('update:value', url)
  }
  formItemContext.onFieldChange()
}
const remove = (info: FileListTypes) => {
  fileList.value = fileList.value?.filter((i) => {
    return i.uid !== info.uid
  })
  change()
}

// updateName
const updateName = (name: string) => {
  // 唯一name
  const hasSome = fileList.value?.some((item) => item.name === name)
  let resultName = name
  const fileType = name.split('.')[1]
  const fileName = name.split('.')[0]
  if (hasSome) {
    let index = 2
    for (let i = 0; i < fileList.value.length; i++) {
      resultName = `${fileName}(${index}).${fileType}`
      const hasIndex = fileList.value?.findIndex((item) => item.name === resultName)
      if (hasIndex === -1) {
        break
      } else {
        index++
      }
    }
  }
  return resultName
}
const isTest = (fileName: string) => {
  if (props.accept) {
    const reg = new RegExp(`.(${props.accept.replace(/[.\s]/g, '').replace(/,/g, '|')})$`)
    return reg.test(fileName)
  } else {
    return true
  }
}
const beforeUpload = (file: any) => {
  if (fileList.value && props.maxCount === fileList.value.length) {
    DcMessage.warning(t('tips.importNumber', { fileNum: props.maxCount }))
    return false
  }
  if (!isTest(file.name)) {
    DcMessage.warning(t('tips.importFileType', { fileType: props.accept }))
    return false
  }
  const isLtM = file.size / 1024 / 1024 > props.fileSize
  if (isLtM) {
    DcMessage.warning(t('tips.importSize10', { fileSize: props.fileSize }))
    return false
  }
}
const customRequest = (file: any) => {
  const newName = updateName(file.file.name)
  const formData = new FormData()
  if (newName !== file.file.name) {
    const renameF = new File([file.file], newName)
    formData.append('files', renameF)
  } else {
    formData.append('files', file.file)
  }
  uploadFile.value = {
    uid: file.file.uid,
    name: newName,
    status: 'upload'
  }
  request({
    url: props.action,
    data: formData,
    method: 'POST',
    headers: {
      'Content-type': 'multipart/form-data'
    },
    onUploadProgress({ total, loaded }) {
      progress.value = 0
      progress.value = Math.round((loaded / (total * 2)) * 100)
    }
  })
    .then((res: any) => {
      if (res.data && res.data[0]) {
        fileList.value = [...fileList.value, fileFormatter(res.data[0])]
        console.log(fileList.value)
      }
      change()
    })
    .catch(() => {
      DcMessage.warning(t('tips.importError'))
    })
    .finally(() => {
      uploadFile.value = undefined
    })
}
const getFileType = (fileName: string) => {
  let suffix = ''
  try {
    const flieArr = fileName.split('.')
    suffix = flieArr[flieArr.length - 1]
  } catch (err) {
    suffix = ''
  }
  if (!suffix) {
    return false
  }
  suffix = suffix.toLocaleLowerCase() // 将后缀所有字母改为小写
  // 匹配 excel
  const excelist = ['xls', 'xlsx']
  if (excelist.find((item) => item === suffix)) {
    return 'excel'
  }
  // 匹配 word
  const wordlist = ['doc', 'docx']
  if (wordlist.find((item) => item === suffix)) {
    return 'word'
  }
  // 匹配 pdf
  const pdflist = ['pdf']
  if (pdflist.find((item) => item === suffix)) {
    return 'pdf'
  }
  // 匹配 pdf
  const pptlist = ['ppt']
  if (pptlist.find((item) => item === suffix)) {
    return 'ppt'
  }
  // 匹配 txt
  const txtlist = ['txt']
  if (txtlist.find((item) => item === suffix)) {
    return 'txt'
  }
  return 'word' // 默认
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_progress = _resolveComponent("a-progress")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_upload, _mergeProps(_ctx.$attrs, {
      "file-list": fileList.value,
      "custom-request": customRequest,
      "before-upload": beforeUpload,
      onRemove: remove
    }), {
      itemRender: _withCtx(({ file, actions }) => [
        _hoisted_2,
        _createElementVNode("div", {
          style: {"display":"flex","align-items":"center"},
          class: _normalizeClass([
            'upload-file-list',
            props.disabled ? 'upload-file-list-disabled' : 'upload-file-list-edit',
            'upload-file-list-view'
          ])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([[file.status === 'error' ? 'error-files' : 'success-files'], "flex1"]),
            style: _normalizeStyle(file.status === 'error' ? 'color: red' : '')
          }, [
            _createElementVNode("img", {
              class: "world-time-item__img",
              src: iconList.value[getFileType(file.name)],
              style: {"margin-right":"4px"}
            }, null, 8, _hoisted_3),
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: actions.download
            }, _toDisplayString(file.name), 9, _hoisted_4)
          ], 6),
          (!(props.disabled || __props.view))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "javascript:;",
                class: "iconfont deleteIcon",
                onClick: actions.remove
              }, _hoisted_7, 8, _hoisted_5))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      default: _withCtx(() => [
        (!__props.view)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (!props.disabled)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.uploadText ? __props.uploadText : _ctx.$t('btn.selectFile')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (tipsComputed.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "tips",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                  }, _toDisplayString(tipsComputed.value), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16, ["file-list"]),
    (uploadFile.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_a_progress, {
              percent: progress.value,
              "stroke-color": "#3FAC46",
              status: "active",
              "stroke-width": 30
            }, null, 8, ["percent"]),
            _createElementVNode("p", {
              class: "upload-progress-percent",
              style: _normalizeStyle({ left: progress.value + '%' })
            }, _toDisplayString(progress.value) + "%", 5)
          ]),
          _createElementVNode("p", null, _toDisplayString(uploadFile.value.name), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})